const initialState = {
  updated: false,
  updating: false,
  error: null,
  items: [],
  nbResult: 0,
};

export const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_PAYMENT_STATUS_PENDING': {
      return {...state, updated: false, updating: true};
      break;
    }
    case 'UPDATE_PAYMENT_STATUS_FULFILLED': {
      const data = action.payload;
      return {
        ...state,
        error: null,
        updated: true,
        updating: false,
        items: data
      };
      break;
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./app/reducers/index/payment.js